import { catalogApi } from "@infrastructure/api";
import { catalogServiceSchema, catalogServicesSchema, } from "../models/catalog-service.schema";
export const catalogServiceRepository = {
    async getAll(params) {
        const response = await catalogApi.getServices(params);
        return catalogServicesSchema.parse(response.data);
    },
    async getById(id) {
        const response = await catalogApi.getService(id);
        return catalogServiceSchema.parse(response.data);
    },
};
export default catalogServiceRepository;
